import moment from "moment";
import "moment/locale/pt-br";
import { WxDayItem, WxSummaryData } from "./types";
import { getWeatherIconSrc, placeholderWeatherIconKey } from "./weatherIcons";

moment.locale("pt-br");

/** Ocorrido: D-7 … D-1 | Previsão: D+1 … D+7 (âncora = hoje, sem incluir hoje). */
export function buildPlaceholderDays(kind: "ocorrido" | "previsao"): WxDayItem[] {
  const today = moment().startOf("day");
  const days: WxDayItem[] = [];

  for (let i = 0; i < 7; i++) {
    const date =
      kind === "ocorrido"
        ? today.clone().subtract(7 - i, "days")
        : today.clone().add(i + 1, "days");

    const weatherKey = placeholderWeatherIconKey(i);

    days.push({
      date: date.format("DD/MM"),
      dayOfWeek: date.format("ddd").replace(".", ""),
      rainMm: null,
      weatherKey,
      iconSrc: getWeatherIconSrc(weatherKey),
    });
  }

  return days;
}

export function buildPlaceholderSummary(): WxSummaryData {
  return {
    totalRainMm: null,
    avgTempC: null,
    avgHumidityPct: null,
  };
}
